// extracted by mini-css-extract-plugin
export default {"dimension":"pfUin","name":"Po7Ci","delimiter":"qiymC","item":"bKbvc"};